var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "span",
    [
      _vm.path.length < 30
        ? [_vm._v(" " + _vm._s(_vm.path) + " ")]
        : [
            _c(
              "v-menu",
              {
                attrs: {
                  "max-width": "400",
                  transition: "slide-y-transition",
                  "close-on-content-click": false,
                  "nudge-width": 200,
                  "offset-x": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function fn(_ref) {
                      var on = _ref.on,
                        attrs = _ref.attrs
                      return [
                        _c(
                          "span",
                          _vm._g(
                            {
                              staticStyle: {
                                cursor: "pointer"
                              }
                            },
                            on
                          ),
                          [
                            _vm._v(
                              _vm._s(_vm.pathParts[0]) +
                                " ... " +
                                _vm._s(_vm.pathParts[1])
                            )
                          ]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.popover,
                  callback: function callback($$v) {
                    _vm.popover = $$v
                  },
                  expression: "popover"
                }
              },
              [
                _c(
                  "v-card",
                  [_c("v-card-text", [_vm._v(" " + _vm._s(_vm.path) + " ")])],
                  1
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }